import { render } from "./Progress.vue?vue&type=template&id=2b4dce40&scoped=true"
import script from "./Progress.vue?vue&type=script&lang=js"
export * from "./Progress.vue?vue&type=script&lang=js"

import "./Progress.vue?vue&type=style&index=0&id=2b4dce40&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-2b4dce40"

export default script